import { http } from 'http';

export default {
  customerMeFull: () => http.get('/bconnect/me-full', { authBtk: true }),

  fetchAccounts: () => http.get('/bconnect/accounts', { authBtk: true }),

  accountDetails: accountId => http.get(`/bconnect/accounts/${accountId}`, { authBtk: true })
};
